import { render, staticRenderFns } from "./pdf-embed-viewer.vue?vue&type=template&id=fdde1e04&scoped=true"
import script from "./pdf-embed-viewer.vue?vue&type=script&lang=js"
export * from "./pdf-embed-viewer.vue?vue&type=script&lang=js"
import style0 from "./pdf-embed-viewer.vue?vue&type=style&index=0&id=fdde1e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdde1e04",
  null
  
)

export default component.exports